// src/api/axiosInstance.js
import axios from 'axios';
import { getCurrentLanguage } from './languageHelper'; // utility function to get language from context or localStorage

const axiosInstance = axios.create({
  baseURL: 'https://cropdarpan.com/', 
  // baseURL: 'http://localhost:3000/',
  headers: {
    'accept-language': 'en_IN', // Default; will be overwritten by interceptor
  },
});

axiosInstance.interceptors.request.use((config) => {
  const language = getCurrentLanguage();
  config.headers['accept-language'] = language || 'en_IN';
  return config;
});

export default axiosInstance;
